import SubmitModal from "./modal"

export default SubmitModal
